import PropTypes from "prop-types";

import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import RichTextEditor from "components/RichEditor/RichTextEditor";

// Kept out of overviewPrimitives so that an overview without a description
// does not import the rich-text editor.
const DescriptionCard = ({ description }) => (
  <Card>
    <CardHeader>
      <CardTitle>Description</CardTitle>
    </CardHeader>
    <CardContent>
      <RichTextEditor content={description} readOnly />
    </CardContent>
  </Card>
);

DescriptionCard.propTypes = {
  description: PropTypes.string.isRequired,
};

export default DescriptionCard;
